<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For Alicja Krawiec, who fought the storm and won.<br/>In celebration.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?50bb2038